import _ from "lodash";
import { convertToMinSecFormat } from "./time_format_helper";

export const TRIAL = "TRIAL";
export const LITE = "LITE";
export const ADVANCED = "ADVANCED";
export const PRO = "PRO";
export const PREMIUM = "PREMIUM";
export const ENTERPRISE = "ENTERPRISE";
export const LIMITS = {
  [TRIAL]: {
    // The 15-day trial is a full Pro trial, so its limits mirror Pro exactly.
    package: TRIAL,
    cdss: 300,
    encounters: Infinity,
    scribes: Infinity,
    minutes: 300,
    // voice_edit: 5,
    icd_cpt_codes: 300,
    each_scribe_minutes: 120,
    ai_voice_edit: 600,
    regen_per_encounter: 3,
  },
  [LITE]: {
    package: LITE,
    cdss: 0,
    encounters: Infinity,
    scribes: Infinity,
    minutes: Infinity,
    // voice_edit: 0,
    icd_cpt_codes: 0,
    each_scribe_minutes: 60,
    ai_voice_edit: 0,
    regen_per_encounter: 3,
  },
  [ADVANCED]: {
    package: ADVANCED,
    cdss: 150,
    encounters: Infinity,
    scribes: Infinity,
    minutes: Infinity,
    // voice_edit: 0,
    icd_cpt_codes: 150,
    each_scribe_minutes: 60,
    ai_voice_edit: 300,
    regen_per_encounter: 3,
  },
  [PRO]: {
    package: PRO,
    // cdss: Infinity,
    cdss: 300,
    encounters: Infinity,
    scribes: Infinity,
    minutes: Infinity,
    // voice_edit: Infinity,
    // icd_cpt_codes: Infinity,
    icd_cpt_codes: 300,
    // each_scribe_minutes: 60,
    each_scribe_minutes: 120, // The time limit has been increased to two hours for the Pro plan.
    ai_voice_edit: 600,
    regen_per_encounter: 3,
  },
  [PREMIUM]: {
    // Premium is the new $99/month plan, replacing Pro for new signups going forward.
    // Same limits as Pro.
    package: PREMIUM,
    cdss: 300,
    encounters: Infinity,
    scribes: Infinity,
    minutes: Infinity,
    icd_cpt_codes: 300,
    each_scribe_minutes: 120,
    ai_voice_edit: 600,
    regen_per_encounter: 3,
  },
  [ENTERPRISE]: {
    package: ENTERPRISE,
    cdss: Infinity,
    encounters: Infinity,
    scribes: Infinity,
    minutes: Infinity,
    // voice_edit: Infinity,
    icd_cpt_codes: Infinity,
    each_scribe_minutes: 60,
    ai_voice_edit: Infinity,
    regen_per_encounter: Infinity,
  },
};

export const EMPTY_PAYLOAD = {
  cdss: 0,
  encounters: 0,
  scribes: 0,
  minutes: 0,
  icd_cpt_codes: 0,
  ai_voice_edit: 0,
  each_scribe_minutes: 0,
};

export function checkExpiration(trialVersion, expirationLimit) {
  for (let key in trialVersion) {
    if (key !== "package" && trialVersion[key] >= expirationLimit[key]) {
      return true;
    }
  }
}

export function formatLicenseData(licenseObj, usageObj, planName) {
  const license = _.cloneDeep(licenseObj);
  
  const isExpired = typeof usageObj?.errorCode === 'string';
  const usage = isExpired ? {} : _.cloneDeep(usageObj);

  const keysToRemove = [
    "minutes",
    "package",
    "encounters",
    "each_scribe_minutes",
    "regen_per_encounter",
  ];
  keysToRemove.forEach((key) => delete license[key]);

  function formatKey(key) {
    const specialCases = {
      ai: "AI",
      cdss: "CDSS",
      icd: "ICD",
      cpt: "CPT",
      codes: "Codes",
      scribes: "Conversations",
      ai_voice_edit: "Hey, Noki (AI Voice Assistant)",
    };

    return (
      specialCases[key] ||
      key
        .split("_")
        .map(
          (word) =>
            specialCases[word] ||
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")
        .replace("Icd Cpt Codes", "ICD CPT Codes")
    );
  }

  const formattedLicenseArray = Object.keys(license).reduce((acc, key) => {
    const formattedKey = formatKey(key);
    const limitValue = String(license[key]);

    let usedValue = usage[key] !== undefined ? String(usage[key]) : "0";

    if (formattedKey === "Hey, Noki (AI Voice Assistant)") {
      const aiVoiceUsage =
        usage["ai_voice_edit_in_ms"] || usage["aiVoiceEditInMs"] || 0;

      usedValue = aiVoiceUsage;
    }

    if (formattedKey === "ICD CPT Codes") {
      usedValue = usage["codesICDCPT"] || "0";
    }

    if (formattedKey === "Conversations") {
      usedValue = usage["conversations"] || "0";
    }

    acc.push({
      feature: formattedKey,
      limit: limitValue,
      value: usedValue,
    });

    return acc;
  }, []);

  const displayOrder = [
    "Conversations",
    "CDSS",
    "ICD CPT Codes",
    "Hey, Noki (AI Voice Assistant)",
  ];
  formattedLicenseArray.sort(
    (a, b) => displayOrder.indexOf(a.feature) - displayOrder.indexOf(b.feature)
  );

  console.log("formattedLicenseArray-", formattedLicenseArray);
  return formattedLicenseArray;
}

export const getNextHigherTierPlan = (currentPlanCode) => {
  const planHierarchy = ["trial", "lite", "advanced", "pro", "enterprise"];

  const currentIndex = planHierarchy.indexOf(currentPlanCode);
  const nextHigherTierPlan =
    currentIndex !== -1 && currentIndex < planHierarchy.length - 1
      ? planHierarchy[currentIndex + 1]
      : null;
  return nextHigherTierPlan;
};